const USER_ROLES = ["Learner", "Admin", "Staff"] as const;

export default USER_ROLES;
